import { useEffect, useRef } from 'react';

import useFeatureStore from '../useFeatureStore';

export const useFeatureMetricsReporter = (): void => {
  const { usageMetricsInterval, reportMetrics } = useFeatureStore();

  const reportRef = useRef(reportMetrics);

  useEffect(() => {
    reportRef.current = reportMetrics;
  }, [reportMetrics]);

  useEffect(() => {
    if (!usageMetricsInterval || usageMetricsInterval <= 0) {
      return;
    }

    let cancelled = false;
    let timer: number | null = null;

    const schedule = (): void => {
      timer = window.setTimeout(tick, usageMetricsInterval);
    };

    async function tick(): Promise<void> {
      if (cancelled) {
        return;
      }

      try {
        await reportRef.current();
      } catch {
        // ignore errors when reporting metrics as
        // they will be retried on the next interval
      }

      schedule();
    }

    // start after one interval
    schedule();

    return (): void => {
      cancelled = true;

      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [usageMetricsInterval]);
};
